import React from "react"
import autobind from "class-autobind"
import AccountStore from "../../../../stores/AccountStore"
import { Toggle, TextField, RaisedButton } from "material-ui"
import strings from "../../../../localization/strings"
import { patchAccount } from "../../../../actions/AccountActions"
interface IProps {
    accountId: string
}
interface IState {
    enableApproveAttestation: boolean
    approveAttestation: string
    errorApproveAttestation: string
}

export default class TimeApprovals extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        const accountSettings = AccountStore.getCurrentAccountSettings()
        this.state = {
            enableApproveAttestation: accountSettings.FeatureSettings.EnableEmpTimecardApproveAttestation,
            approveAttestation: accountSettings.FeatureSettings.EmpTimecardApproveAttestation || "",
            errorApproveAttestation: ""
        }
        autobind(this)
    }

    handleSave() {
        if (!this.checkValidate()) return
        const approveAttestation = this.state.approveAttestation.trim()
        patchAccount(this.props.accountId, {
            AccountSettings: {
                FeatureSettings: {
                    EnableEmpTimecardApproveAttestation: this.state.enableApproveAttestation,
                    EmpTimecardApproveAttestation: approveAttestation ? approveAttestation : null
                }
            }
        })
    }

    checkValidate() {
        let isValid = true
        if (this.state.enableApproveAttestation) {
            if (!this.state.approveAttestation.trim()) {
                this.setState({ errorApproveAttestation: strings.This_field_is_required })
                isValid = false
            }
            else {
                this.setState({ errorApproveAttestation: null })
            }
        }
        else {
            this.setState({ errorApproveAttestation: null })
        }
        return isValid
    }

    render() {
        const accountSettings = AccountStore.getCurrentAccountSettings()
        const enableApproveAttestation = accountSettings.FeatureSettings.EnableEmpTimecardApproveAttestation
        const approveAttestation = accountSettings.FeatureSettings.EmpTimecardApproveAttestation || ""
        return (
            <div style={{ position: "relative", minHeight: 130 }}>
                <Toggle
                    toggled={this.state.enableApproveAttestation}
                    onToggle={(e, value) =>
                        this.setState({
                            enableApproveAttestation: value,
                            approveAttestation: value ? this.state.approveAttestation : ""
                        }, () => this.checkValidate())
                    }
                    labelPosition="left"
                    label={strings.Enable_Timecard_Approval_Attestation}
                    style={{ maxWidth: 300 }}
                />
                {this.state.enableApproveAttestation &&
                    <TextField
                        fullWidth
                        floatingLabelText={strings.Attestation_Text}
                        value={this.state.approveAttestation}
                        onChange={(e, value) => this.setState({ approveAttestation: value }, () => this.checkValidate())}
                        errorText={this.state.errorApproveAttestation}
                    />
                }
                {(enableApproveAttestation !== this.state.enableApproveAttestation || approveAttestation !== this.state.approveAttestation.trim()) &&
                    <RaisedButton
                        secondary
                        label={strings.Save}
                        style={{ position: "absolute", right: 20, bottom: -10 }}
                        onTouchTap={this.handleSave}
                    />
                }
            </div>
        )
    }
}